import { render } from "./newCommerciaux.vue?vue&type=template&id=56317c38&scoped=true"
import script from "./newCommerciaux.vue?vue&type=script&lang=js"
export * from "./newCommerciaux.vue?vue&type=script&lang=js"

import "./newCommerciaux.vue?vue&type=style&index=0&id=56317c38&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56317c38"]])

export default __exports__